export enum YesNoChoice {
    Yes = 'YES',
    No = 'NO',
}
